export default __webpack_public_path__ + "static/media/cash.71b329a1.svg";